<template>
  <a-modal
      :title="title"
      :width="1020"
      :visible="visible"
      :confirmLoading="loading"
      :destroyOnClose="true"
      :footer="null"
      @cancel="cancel"
  >
    <a-spin :spinning="loading">
      <div class="table-operator">
        <a-button type="primary" @click="handleAdd">增加发放记录</a-button>
      </div>
      <s-table
          ref="table"
          rowKey="grantlog_id"
          :loading="isLoading"
          :columns="columns"
          :data="loadData"
          :pageSize="15"
          :scroll="{y:500}"
      >
        <div slot="grant_type" slot-scope="text, item">
          <a-tag color="green" v-if="text==0">微信</a-tag>
          <a-tag color="green" v-if="text==1">现金</a-tag>
          <a-tag color="green" v-if="text==2">银行转账</a-tag>
        </div>
        <div slot="amount" slot-scope="text, item">
          <span style="color: red">￥</span> {{ text }}
        </div>
        <div class="actions" slot="action" slot-scope="text, item">
          <!--          <a v-action:edit @click="handleEdit(item)">编辑</a>-->
          <a-popconfirm
              title="确认删除当前记录？"
              ok-text="确定"
              cancel-text="取消"
              @confirm="handleDelete(item)"
          >
            <a href="#">删除</a>
          </a-popconfirm>
        </div>
      </s-table>

      <SaveGrantlogForm
          :payroll_id="queryParam.payroll_id"
          ref="SaveGrantlogForm"
          @handleSubmit="handleRefresh"
      />
    </a-spin>
  </a-modal>
</template>
<script>
import * as Api from '@/api/personnel/grantlog'
import {STable} from "@/components";
import SaveGrantlogForm from './SaveGrantlogForm'

export default {
  name: "GrantLogModel",
  components: {
    STable,
    SaveGrantlogForm
  },
  data() {
    return {
      title: '',
      queryParam: {
        payroll_id: '',
        payroll_type: '',
      },
      visible: false,
      loading: false,
      isLoading: false,
      columns: [
        {
          title: '发放人',
          dataIndex: 'grant_user.real_name',
        },
        {
          title: '发放方式',
          width: 60,
          dataIndex: 'grant_type',
          scopedSlots: {customRender: 'grant_type'}
        },
        {
          title: '发放金额',
          dataIndex: 'amount',
          align: 'center',
          scopedSlots: {customRender: 'amount'}
        },
        {
          title: '发放时间',
          dataIndex: 'create_time',
          align: 'center',
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: {customRender: 'action'}
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: param => {
        return Api.list({...param, ...this.queryParam})
            .then(response => {
              return response.data.list
            })
      }
    }
  },
  methods: {
    open() {
      this.title = '发放记录'
      this.visible = true
    },

    cancel() {
      this.visible = false
      this.$emit('handleSubmit')
    },

    /**
     * 添加
     */
    handleAdd() {
      this.$refs.SaveGrantlogForm.add()
    },

    /**
     * 编辑
     */
    handleEdit(item) {
      this.$refs.SaveGrantlogForm.edit(item)
    },

    handleDelete(item) {
      Api.deleted({grantlog_id: item['grantlog_id']})
          .then((result) => {
            this.$message.success(result.message, 1.5)
            this.handleRefresh()
          })
    },

    /**
     * 搜索
     */
    handleSeachSubmit(value) {
      this.queryParam = {
        ...this.queryParam,
        ...value
      }
      this.handleRefresh(true)
    },


    /**
     * 刷新列表
     * @param Boolean bool 强制刷新到第一页
     */
    handleRefresh(bool = false) {
      this.$refs.table.refresh(bool)
    },
  }
}
</script>
<style scoped lang="less">

</style>
